/*:: type Score = Array<[number, number]>*/

/* eslint no-multi-spaces: 0 */
class CollectionScores {
  // Continuous
  // [[meters,       score], [...], ...]
  // [[seconds,      score], [...], ...]
  // [[seconds,      score], [...], ...]
  // [[0.00 to 1.00, score], [...], ...]
  // Binary
  // [[0, score], [1, score]]
  // [[0, score], [1, score]]
  // [[0, score], [1, score]]

  /*:: static serialize: (CollectionScores) => Object; */
  constructor(scores
  /*: Object*/
  ) {
    if (!scores) throw new Error('Missing required argument "scores".');
    this.distance = scores.distance || [];
    this.age = scores.age || [];
    this.businessAge = scores.businessAge || [];
    this.random = scores.random || [];
    this.featured = scores.featured || [];
    this.limited = scores.limited || [];
    this.exclusive = scores.exclusive || [];
  }

}

CollectionScores.serialize = (collectionScores
/*: ?CollectionScores*/
) => {
  if (!collectionScores) return {};
  return {
    distance: collectionScores.distance.length ? collectionScores.distance : undefined,
    age: collectionScores.age.length ? collectionScores.age : undefined,
    businessAge: collectionScores.businessAge.length ? collectionScores.businessAge : undefined,
    random: collectionScores.random.length ? collectionScores.random : undefined,
    featured: collectionScores.featured.length ? collectionScores.featured : undefined,
    limited: collectionScores.limited.length ? collectionScores.limited : undefined,
    exclusive: collectionScores.exclusive.length ? collectionScores.exclusive : undefined
  };
};

module.exports = CollectionScores;